import type { Transition } from "@uirouter/core";

import Sentry from "@similarweb/sentry-logger";

import { keywordsRedirectCases } from "./redirect-handlers/keywords";
import { trademarksRedirectCases } from "./redirect-handlers/trademarks";
import type { IRedirectCase } from "./redirect-handlers/types";

export function onRedirectHandler(redirectCasesList: IRedirectCase[]) {
    return async function TransitionHookFn(transition: Transition) {
        for (const redirectCase of redirectCasesList) {
            try {
                const result = await redirectCase.handler(transition);
                if (result) {
                    return result;
                }
            } catch (error) {
                Sentry.errorTracker({
                    e: error,
                    message: `Error in redirect case: ${redirectCase.name}`,
                    level: "error",
                    params: {
                        extra: {
                            redirectCase: redirectCase.name,
                            toParams: transition.params(),
                            toState: transition.to().name,
                        },
                    },
                });
                // Continue to next case on error
            }
        }

        // If no redirect case applies, allow the transition to proceed
        return;
    };
}

export const onRedirectToMonitorAndProtectReport = onRedirectHandler(keywordsRedirectCases);
export const onRedirectToTrademarkReport = onRedirectHandler(trademarksRedirectCases);
